export default {
  MODULE_ADMIN : 'admin',
  MODULE_ADMIN_DASHBOARD : 'admin_dashboard',
  MODULE_ADMIN_ABONNEMENTS : 'list_abonnements',
  MODULE_ADMIN_HISTORIC : 'admin_historic',
    
  MODULE_NEOPASS_FORM : 'neopass',
  MODULE_NEOPASS_FORM_CV_PROFESSIONNEL : 'cv',
  MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES : 'compperso',
  MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO : 'compsocio',
  MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES : 'comppro',
  MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES : 'compsco',
  MODULE_NEOPASS_FORM_PLAN_ACCOMPAGNEMENT : 'plan',
  MODULE_NEOPASS_FORM_PRECONISATIONS : 'preconisation',
  MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS : 'depotdocuments',
    
  MODULE_CARTOGRAPHIES_COLLECTIVES : 'collectives',
  MODULE_CARTOGRAPHIES_INDIVIDUELLES : 'individuelles',
    
  MODULE_NEOPASS_LISTE : 'neopassList',
  MODULE_CURRICULUM_VITAE : 'curriculum_vitae',
  MODULE_FICHE_DE_POSTE : 'job_description',
  MODULE_MODELE_DE_PAGE : 'templates',
  MODULE_GESTION_DES_DROITS : 'droits_restrictions',
  MODULE_PARAMETRES_COMPTE : 'parametres_compte',
  MODULE_REFERENTIEL_FORMATION : 'ref_formations',
  MODULE_DEPOT_DOCUMENTS : 'depot_docs',
  MODULE_RECHERCHE_COMPETENCES : 'recherche_competences',
  MODULE_COMPETENCES: 'competences'
};